import React from 'react'
import { Layout } from 'pcln-design-system'
import ScrollableDealModule from '@/components/ScrollableDealModule'
import HOTELS_DEAL_MODULE_CONTENT from './constants'

const HotelsDealModules = () => {
  return (
    <Layout variation="100" rowGap="xl">
      <ScrollableDealModule
        content={HOTELS_DEAL_MODULE_CONTENT}
        isUsingNavArrows={false}
        handleNavOnClick={(href: string) => window.open(href)}
        isUsingPriceType={false}
        isUsingPricePrefix
        isOpaque={false}
      />
    </Layout>
  )
}
export default HotelsDealModules
